<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="width"
    viewBox="0 0 612 612"
  >
    <path
      :fill="iconColor"
      d="M612 116.3a250.7 250.7 0 0 1-72 19.7A126 126 0 0 0 595 66.6a253.1 253.1 0 0 1-79.8 30.5 125.6 125.6 0 0 0-214 114.5A356.4 356.4 0 0 1 42.7 80.4 125.5 125.5 0 0 0 81.5 248c-20.6-.7-40-6.4-56.9-15.8v1.6c0 60.8 43.3 111.5 100.7 123a127.2 127.2 0 0 1-56.7 2.1c16 50 62.3 86.2 117.3 87.2A251.9 251.9 0 0 1 0 498.1a354.9 354.9 0 0 0 192.4 56.5c231 0 357.2-191.3 357.2-357.2l-.4-16.3c24.7-17.6 46-39.7 62.8-64.8z"
    /></svg
></template>

<script>
export default {
  name: "TwitterIcon",
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>

<style scoped></style>
